var map = {
	"./avatar.svg": "56fc",
	"./bg.jpg": "d1b4",
	"./logo.svg": "1ae4",
	"./logo_1.svg": "d9b6",
	"./logo_2.svg": "7397",
	"./logo_3.svg": "6592",
	"./logo_common.svg": "5c50",
	"./menu_0_nomal.png": "4b23",
	"./menu_0_select.png": "4d1a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";